export default {
  setName (state, name) {
    state.name = name
  },
  setFullPath (state, path) {
    state.fullPath = path
  }
}
